import { useEffect } from "react";
import { useTranslation } from "react-i18next"
import { Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { login } from "../api";
import botconfig from "../botconfig";
export function LoginPage() {
    const { t } = useTranslation()
    const [messageApi, contextHolder] = message.useMessage()
    function errorMessage(error) {
        console.error(error)
        messageApi.open({
            type: 'error',
            content: error.message,
        });
    }
    useEffect(() => {
        async function preload() {
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code')
            if (code) {
                try {
                    await login({ grant_type: "authorization_code", code, redirect_uri: `${botconfig.root_path}${botconfig.website_port}/login` })
                    let localItem = JSON.parse(localStorage.getItem("wetbot"))
                    return window.location.replace(localItem?.redirect_uri || `${botconfig.root_path}${botconfig.website_port}/servers`)
                } catch (err) {
                    return errorMessage(err)
                }
            }
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (!localItem) {
                localStorage.setItem("wetbot", JSON.stringify({ redirect_uri: document.referrer || `${botconfig.root_path}${botconfig.website_port}/servers` }))
            } else {
                localStorage.setItem("wetbot", JSON.stringify({ ...localItem, redirect_uri: document.referrer || `${botconfig.root_path}${botconfig.website_port}/servers` }))
            }
            return window.location.replace(botconfig.redirect_uri)
        }
        preload()
    }, [])
    return (
        <>
            {contextHolder}
            <Spin style={{ width: "100%", height: "100%", position: "absolute", display: "flex", justifyContent: "center", alignItems: "center" }} indicator={<LoadingOutlined style={{ fontSize: 300, color: "var(--cookie-color)" }} spin />} />
        </>
    )
}